import { useState, useEffect } from 'react';
import { addBreadcrumb } from '@sentry/react';

import { usePaymentProvider } from './use-payment-provider.hook';

export const useIsGooglePayAvailable = (): { loading: boolean; available: boolean } => {
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(false);
  const paymentProvider = usePaymentProvider();

  useEffect(() => {
    const exec = async () => {
      const isGooglePayAvailable = await paymentProvider.getIsGooglePayAvailable();
      setAvailable(isGooglePayAvailable);
    };
    exec()
      .catch(() => addBreadcrumb({ message: '[useIsGooglePayAvailable] failed to check GooglePay availability' }))
      .finally(() => setLoading(false));
  }, [paymentProvider]);

  return { loading, available };
};
